import { render, staticRenderFns } from "./stanford.vue?vue&type=template&id=5de09f25&"
import script from "./stanford.vue?vue&type=script&lang=js&"
export * from "./stanford.vue?vue&type=script&lang=js&"
import style0 from "./stanford.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports